module.exports = __webpack_public_path__ + "img/fluent_sparkle-32-filled.a06399af.svg";